import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import * as decode from 'jwt-decode';
import { AngularFireDatabase } from 'angularfire2/database';
import { DataSnapshot } from '@firebase/database-types';

@Injectable()
export class AuthService {
    token: string;
    private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private isAdmin$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private router: Router, private db: AngularFireDatabase) {}

    get isLoggedIn() {

        if (localStorage.getItem('currentUserToken')) {
          this.loggedIn.next(true);
        } else {
          this.loggedIn.next(false);
        }
        return this.loggedIn.asObservable();
    }

    signupUser(email: string, password: string) {
        firebase.auth().createUserWithEmailAndPassword(email, password)
        .then((user: firebase.User) => {
            const savedData = this.db.list('users');
            savedData.push({ usercode: firebase.auth().currentUser.uid, username: email});
            this.router.navigate(['/login']);
        })
        .catch(
            error => console.log(error)
        );
    }

    signinUser(email, password) {
        firebase.auth().signInWithEmailAndPassword(email, password)
        .then(
            (response) => {
                firebase.auth().onAuthStateChanged((user) => {
                    if ( user ) {
                        user.getIdToken()
                        .then(
                            (token: string) => {
                                this.token = token;
                                localStorage.setItem('currentUserToken', token);
                                this.router.navigate(['/']);
                            }
                        );
                    }
                });
            }
        )
        .catch(
            error => console.log(error)
        );
    }

    getToken(): string {
        if (localStorage.getItem('currentUserToken')) {
            return localStorage.getItem('currentUserToken');
        } else {
            return null;
        }
    }

    getUserId(): string {
        if (localStorage.getItem('currentUserToken')) {
            return decode(localStorage.getItem('currentUserToken')).user_id;
        } else {
            return '';
        }
    }

    getUserName(): string {
        if (localStorage.getItem('currentUserToken')) {
            return decode(localStorage.getItem('currentUserToken')).email;
        } else {
            return null;
        }
    }

    logout() {
        localStorage.removeItem('currentUserToken');
        this.loggedIn.next(false);
        this.router.navigate(['/login']);
    }

    get isAdmin() {
        let isAdmin = false;
        const savedData = this.db.database.ref('users').orderByChild('usercode').equalTo(this.getUserId())
        .once('value')
        .then((snapshot: DataSnapshot) => {
            snapshot.forEach((childSnapshot) => {
                isAdmin = childSnapshot.val().isAdmin;
                if (isAdmin) {
                    this.isAdmin$.next(true);
                } else {
                    this.isAdmin$.next(false);
                }

                return false;
            });
        });
        return this.isAdmin$.asObservable();
    }

    unsubscribeIsAdmin() {
        this.isAdmin$.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-service.ts